var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"info","clipRule":"evenodd","d":"M17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17C13.1944 17 17 13.1944 17 8.5ZM1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5ZM9 5V6H8V5H9ZM9 12V7H8V12H9Z"}));
}

Info.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17"};

module.exports = Info;

Info.default = Info;
